import React from "react";
import styles from "./calendar.module.css";
import { WeekHeaderDisplay } from "../../types/public-types";

type CalendarBottomTextProps = {
  textMap: Record<WeekHeaderDisplay, string>;
  x: number;
  y: number;
  maxWidth: number;
  fontFamily?: string;
  fontSize?: string;
  weekHeaderDisplay: WeekHeaderDisplay;
};

const getFontSize = (fontSize?: string) => {
  if (!fontSize) return 14;
  const parsed = parseInt(fontSize, 10);
  return Number.isNaN(parsed) ? 14 : parsed;
};

const getRelevantText = (
  text: string,
  maxChars: number,
): { display: string; isTruncated: boolean } | null => {
  if (maxChars <= 0 || text.length <= maxChars) {
    return { display: text, isTruncated: false };
  }

  return null;
};

const textPriorityOrder = [
  WeekHeaderDisplay.Both,
  WeekHeaderDisplay.DateRange,
  WeekHeaderDisplay.Week,
];

const truncateText = (
  textMap: Record<WeekHeaderDisplay, string>,
  weekHeaderDisplay: WeekHeaderDisplay,
  maxWidth: number,
  fontSize: number
): { display: string; isTruncated: boolean } => {
  const avgCharWidth = fontSize * 0.55;
  const maxChars = Math.floor((maxWidth - 8) / avgCharWidth);

  const startingIndex = textPriorityOrder.indexOf(weekHeaderDisplay);
  for (let i = startingIndex; i < textPriorityOrder.length; i++) {
    const text = textMap[textPriorityOrder[i]];
    const relevantText = getRelevantText(text, maxChars);
    if (relevantText) {
      return relevantText;
    }
  }

  return { display: textMap[WeekHeaderDisplay.Week], isTruncated: false };
};

export const CalendarBottomText: React.FC<CalendarBottomTextProps> = ({
  textMap,
  weekHeaderDisplay,
  x,
  y,
  maxWidth,
  fontFamily,
  fontSize,
}) => {
  const parsedFontSize = getFontSize(fontSize);
  const { display } = truncateText(textMap, weekHeaderDisplay, maxWidth, parsedFontSize);

  return (
    <text
      y={y}
      x={x}
      className={styles.calendarBottomText}
      fontFamily={fontFamily}
      fontSize={fontSize}
    >
      {display}
    </text>
  );
};
